var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66927 1.39232L2.73594 0.333984L16.6693 14.2673L15.6109 15.334L13.0443 12.7673C12.0859 13.084 11.0693 13.2507 10.0026 13.2507C5.83594 13.2507 2.2776 10.659 0.835938 7.00065C1.41094 5.53398 2.3276 4.24232 3.49427 3.21732L1.66927 1.39232ZM10.0026 4.50065C10.6656 4.50065 11.3015 4.76404 11.7704 5.23288C12.2392 5.70172 12.5026 6.33761 12.5026 7.00065C12.503 7.28446 12.4551 7.56626 12.3609 7.83398L9.16927 4.64232C9.43699 4.54814 9.7188 4.50023 10.0026 4.50065ZM10.0026 0.750651C14.1693 0.750651 17.7276 3.34232 19.1693 7.00065C18.4887 8.72809 17.3331 10.2276 15.8359 11.3257L14.6526 10.134C15.8051 9.33686 16.7345 8.25824 17.3526 7.00065C16.679 5.62554 15.6331 4.46701 14.3337 3.65678C13.0344 2.84655 11.5338 2.41712 10.0026 2.41732C9.09427 2.41732 8.2026 2.56732 7.36927 2.83398L6.08594 1.55898C7.28594 1.04232 8.61094 0.750651 10.0026 0.750651ZM2.6526 7.00065C3.32623 8.37576 4.37215 9.53429 5.67147 10.3445C6.97078 11.1548 8.47136 11.5842 10.0026 11.584C10.5776 11.584 11.1443 11.5257 11.6693 11.409L9.76927 9.50065C9.18941 9.4385 8.64829 9.17971 8.23592 8.76734C7.82354 8.35496 7.56476 7.81385 7.5026 7.23398L4.66927 4.39232C3.84427 5.10065 3.1526 5.98398 2.6526 7.00065Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewHide);
export default __webpack_public_path__ + "static/media/View_hide.732bbdd40690c7405c2ae917a1f98948.svg";
export { ForwardRef as ReactComponent };